import { AddUserIcon, Button, Header, MailIcon, Paragraph, TextInput, notification } from "@datagame/ui";
import { Field, Form, Formik } from "formik";
import { object, string } from "yup";
import { useMutation } from "@apollo/client";
import { useTranslation } from "react-i18next";

import { USER_INVITE } from "../../../../graphql/mutations/UserMutations";
import { FieldWrapper } from "../../../shared/ui/FieldWrapper";

import styles from "./InviteUsersForm.module.scss";

export interface InviteFormValues {
  email: string;
}

export const InviteUsersForm = () => {
  const { t } = useTranslation();

  const [userInvite, { loading: userInviteLoading }] = useMutation(USER_INVITE, {
    refetchQueries: ["UserList"],
    onCompleted: (data) => {
      notification.success({
        title: "",
        description: t("user:notification:userInvited", { email: data.userInvite.email }),
      });
    },
    onError: (e) => {
      notification.danger({ title: "", description: e.message });
    },
  });

  const initialValues: InviteFormValues = {
    email: "",
  };

  const validationSchema = object({
    email: string().email().required(),
  });

  const handleSubmit = (values: InviteFormValues, { resetForm }: { resetForm: () => void }) => {
    userInvite({
      variables: {
        email: values.email,
      },
    });

    resetForm();
  };

  return (
    <div className={styles.sectionWrapper}>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
        validateOnBlur={false}
        validateOnChange={false}
      >
        {() => (
          <Form className={styles.inviteSection}>
            <div className={styles.headerWrapper}>
              <div className={styles.content}>
                <Header variant="h5">{t("company:inviteSection.title")}</Header>
                <Paragraph size="small">{t("company:inviteSection.description")}</Paragraph>
              </div>
              <Button
                iconSide="left"
                icon={<AddUserIcon />}
                className={styles.button}
                type="submit"
                disabled={userInviteLoading}
              >
                {t("company:inviteSection.button")}
              </Button>
            </div>

            <FieldWrapper name="email" label="">
              <Field
                placeholder={t("user:form:placeholder:email")}
                name="email"
                type="email"
                as={TextInput}
                icon={<MailIcon />}
              />
            </FieldWrapper>
          </Form>
        )}
      </Formik>
    </div>
  );
};
